import { z } from 'zod'

export const publicarNovedadSchema = z.object({
  titulo: z
    .string()
    .trim()
    .min(1, 'El título es requerido')
    .max(80, 'El título no puede superar los 80 caracteres'),
  mensaje: z
    .string()
    .trim()
    .min(1, 'El texto es requerido')
    .max(500, 'El texto no puede superar los 500 caracteres'),
})

export type PublicarNovedadFormValues = z.infer<typeof publicarNovedadSchema>
